import PropTypes from 'prop-types';
import React from 'react';

/**
 * External link presentational component.
 * Wraps links with target and rel attributes to open safely in a new window.
 */
const ExternalLink = (props) => {
  const { follow } = props;
  let rel = 'noopener noreferrer';
  if (!follow) {
    rel += ' nofollow';
  }

  return (
    <a target="_blank" rel={rel} {...{ ...props, follow: undefined }}>
      {props.children}
    </a>
  );
};

ExternalLink.propTypes = {
  /**
   * Children contents of the link.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  follow: PropTypes.bool,
  href: PropTypes.string,
  className: PropTypes.string,
};

ExternalLink.defaultProps = {
  follow: false,
  href: '',
  className: undefined,
};

export default ExternalLink;
